import React from "react";
import { useTranslation } from "react-i18next";
import underlineimage from "../assets/images/title-shape.png";
import friendinvite from "../assets/images/Homepagesec/Homepageroundimgs/homeesports.png";
import frnbbg from "../assets/images/Homepagesec/esportssec.png";

const Esports = () => {
  const { t } = useTranslation();

  return (
    <div
      className="bg-cover bg-no-repeat bg-center text-center py-16 px-4 md:px-10 lg:px-20"
      style={{ backgroundImage: `url(${frnbbg})` }}
    >
      {/* Title */}
      <h2 className="text-[36px] md:text-[48px] font-oswald font-extrabold text-[#ffffff]">
        {t("esportst.title")}
      </h2>

      {/* Underline Image */}
      <img
        src={underlineimage}
        alt="underline"
        className="mx-auto mt-2 mb-6 w-[120px] h-auto"
      />

      {/* Tagline */}
      {/* <p className="text-[16px] md:text-[18px] font-proxima font-medium text-[#070B28] leading-relaxed mb-11">
        {t("esportst.tagline")}
      </p> */}

      {/* Image Left - Text Right Block */}
      <div className="flex flex-col md:flex-row items-center justify-between gap-10 md:gap-20 max-w-6xl mx-auto mt-3">
        {/* 🖼️ Image Left */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src={friendinvite}
            alt={t("esportst.inviteImageAlt")}
            className="w-full max-w-[350px] md:max-w-[400px] h-auto"
          />
        </div>

        {/* 📝 Text Right */}
        <div className="w-full md:w-1/2 text-center md:text-left">
          <p className="text-[18px] md:text-[22px] font-oswald font-semibold text-[#ffffff] max-w-xl mx-auto md:mx-0">
           {t("esportst.tagline")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Esports;
